import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useCallback } from 'react';

interface SmartLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const SmartLink = ({ href, children, className, onClick }: SmartLinkProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';
  const isHashLink = href.startsWith('#');

  const handleClick = useCallback((e: React.MouseEvent) => {
    if (onClick) onClick();

    if (isHashLink) {
      if (isHome) {
        // Already on home, just scroll
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Navigate to home first, then scroll
        e.preventDefault();
        navigate('/' + href);
        // After navigation, scroll to the element
        setTimeout(() => {
          const element = document.querySelector(href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    }
  }, [href, isHome, isHashLink, navigate, onClick]);

  // For route links (starting with /), use Link
  if (href.startsWith('/') && !href.includes('#')) {
    return (
      <Link to={href} className={className} onClick={onClick}>
        {children}
      </Link>
    );
  }

  // For hash links, handle smart navigation
  return (
    <a href={href} className={className} onClick={handleClick}>
      {children}
    </a>
  );
};

export default SmartLink;
